import useLenis from "@/hooks/useLenis";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Ribbon from "@/components/site/Ribbon";
import Services from "@/components/site/Services";
import Portfolio from "@/components/site/Portfolio";
import Process from "@/components/site/Process";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function HomePage() {
  useLenis();
  return (
    <div className="bg-background">
      <Nav />
      <main>
        <Hero />
        <Ribbon dark />
        <Services />
        <Portfolio />
        <Process />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
